<div class="container">
  <div class="confirm-signup-container" *ngIf="!success">
    <h2>Confirm Sign Up</h2>
    <div>
      <p>A verification link was sent to your email address.<br>
        Click on the link to verify your account, then come back to sign in!
      </p>
      <p *ngIf="error != ''" class="warning-text">{{error}}</p>
      <p>Didn't receive a verification link? Be sure to check your spam folder, or <a role="button" (click)="handleResend()" class="login-link">click here to resend a new link</a>.</p>
    </div>
  </div>
  <signup-successful *ngIf="success"></signup-successful>
</div>